export default [
  'bg',
  'cs',
  'da',
  'de',
  'en',
  'es',
  'fi',
  'fj',
  'fr',
  'hu',
  'id',
  'it',
  'ja',
  'km',
  'ko',
  'mn',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'ru',
  'sk',
  'sm',
  'sq',
  'sv',
  'th',
  'tl',
  'to',
  'vi',
  'zh',
]
